import { makeStyles } from '@material-ui/core';
import { inherits } from 'util';
import Colors from '../../components/Colors';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexFlow: 'column',
    // border: ' 0.5px solid rgba(0, 0, 0, 0.2)',
    // boxSizing: 'border-box',
    // boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    marginTop: '2%',
  },

  root: {
    display: 'flex',
    flexFlow: 'column',
    width: '100%',
    padding: '2% 0 3% 0%',
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  root2: {
    display: 'flex',
    flexFlow: 'column',
    background: '#F2F2F2',
    width: '100%',

    padding: '2% 0 3% 0%',
    [theme.breakpoints.down('sm')]: {},
  },

  small: {
    display: 'none',
    marginTop: '2%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
    },
  },

  containerMap: {
    width: '100%',
    height: '300px',
    border: '0.5px solid rgba(0, 0, 0, 0.5)',
    zIndex: 0,
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  actionBtnsDiv: {
    displat: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  actionBtn: {
    margin: '5px 0',
    backgroundColor: Colors.secundary,
    color: '#404040',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: Colors.hoverMain,
    },
  },

  // buttons: {
  //   border: '0px solid transparent',
  //   marginRight: '2%',
  //   borderRadius: '0',
  //   color: Colors.secundary,
  //   fontWeight: 'bolder',
  // },
  buttonActive: {
    marginRight: '2%',
    backgroundColor: Colors.secundary,
    color: '#404040',
    fontWeight: 'bolder',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '100%',
    height: '60%',
    overflow: 'scroll',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
  },
  header: {
    width: '100%',
    backgroundColor: Colors.secundary,
    color: '#404040',
    fontWeight: 'bold',
    padding: '3% 0 3% 0',
    textAlign: 'center',
    margin: '4% 0 2% 0',
  },
  loadingContainer: {
    display: 'flex',
    marginTop: '30px',
    justifyContent: 'center',
  },
  loadingSpinner: {
    color: Colors.secundary,
  },
  listImages: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageItem: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    height: '200px',
    overflow: 'hidden',
    margin: '10px 0',
    borderRadius: 5,
    boxShadow: theme.shadows[1],
    backgroundColor: '#FFFFFF',
  },
  image: {
    width: 180,
    height: 180,
    objectFit: 'cover',
    cursor: 'pointer',
    borderRadius: 5,
    '&:hover': {
      boxShadow: theme.shadows[2],
    },
  },
  descContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    marginLeft: 20,
    padding: 10,
  },
  imgDescription: {
    width: '100%',
    height: '100%',
  },
  headerTitle: {
    width: '70%',
    fontSize: 14,
    padding: 8,
    color: '#404040',
    backgroundColor: Colors.secundary,
    textAlign: 'center',
  },
  textRow: {
    border: '1px solid #CCCCCC',
    textAlign: 'center',
    width: '70%',
    padding: 8,
  },
  damageForm: {
    width: '100%',
    padding: '1rem 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '1px solid #808080',
  },

  tableContainer: {
    margin: '30px 0 80px',
    padding: '5px 20px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '0px',
    },
  },

  table: {
    backgroundColor: 'white',
    boxShadow: theme.shadows[1],
  },

  tableHead: {
    backgroundColor: '#7acf89',
    '& th': {
      color: '#404040',
    },
  },

  responsive: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  tablesComparison: {
    display: 'flex',
    flexDirection: 'row',
  },
  
  tableRows: {
    display: 'flex',
    flexDirection: 'row',
    gap: '5%',
  },
  
  rowItem: {
    display: 'flex',
    maxWidth: '50%',
  },

  tableComparison: {
    Width: '100%',
  },

  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    // width: 'inherit',
    minWidth: 200,
    gap: '1%',

    paddingTop: '1%',
    [theme.breakpoints.up('md')]: {
      top: '160px',
    },
    [theme.breakpoints.down('sm')]: {
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      maxWidth: 500,
      marginBottom: 15,
      marginLeft: 0,
    },
  },

  buttonWrapper: {
    width: '100%',
    position: 'relative',
    backgroundColor: 'yellow',
  },

  buttons: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      textTransform: 'none',
      minWidth: '100%',
      // margin: 3,
    },
  },

  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },

  titleTable: {
    width: '100%',
    // paddingLeft: 2,
    borderBottom: '3px solid #7acf89',
    color: 'grey',
    borderRadius: 3,
    marginBottom: 6,
    // backgroundColor: '#7acf89',
  },
}));
